<template>
  <div class="lp-sort-drop-down-container">

    <!-- Basic -->
    <div class="sort-drdn-select-wrapper" @click="openList">
      <div class="sort-drdn-select-item">
        {{ selectedVal }}
      </div>
      <i v-if="!isOpen" @click.stop.prevent="isOpen=true" class="material-icons sort-drdn-arrow-icon"
         >keyboard_arrow_down</i>
      <i v-if="isOpen" @click.stop.prevent="isOpen=false" class="material-icons sort-drdn-arrow-icon"
         >keyboard_arrow_up</i>
    </div>

    <ul v-if="isOpen" class="sort-drdn-list">
      <li class="sort-drdn-item" v-for="(item,idx) in list" :key="'sort-list'+idx" @click="clickTargetItem(item, idx)"
          >
        {{ item.label }}
      </li>
    </ul>

  </div>
</template>

<script>
  import moment from 'moment';

  export default {
    props: [
      'data', 'list'
    ],
    data() {
      return {
        isOpen: false,
        selectedVal: '',
        regionList: [],
        // isDateShow: false
      }
    },
    created() {
      if (this.data !== undefined) {
        this.selectedVal = this.data;
      }
    },
    watch: {
      data(n) {
        this.selectedVal = n;
      },
      list(n) {
        this.selectedVal = this.placeholder;
      }
    },
    methods: {
      openList() {
        this.isOpen ? this.isOpen = false : this.isOpen = true;
      },
      clickTargetItem(item, idx) {
        this.selectedVal = item.label;
        this.$emit('onSelect', {label:item.label, value:item.value, parent:item.parent});
        this.isOpen = false;
      }
    }
  }
</script>

<style>
  .sort-date-picker-wrap {
    height: 32px;
  }
  .sort-date-picker-cal {
    top: 46px;
  }
  .sort-date-picker-input {
    width: 100%;
    border: none;
    background: transparent;
    height: 30px;
    padding-left: 12px;
    color: transparent;
    cursor: pointer;
  }
</style>


<style lang="stylus" type="stylus" scoped>
  //@import '~assets/css/reset'
  .lp-sort-drop-down-container
    font-size 0.9rem
    position relative
  .sort-drdn-select-wrapper
    background #f2f7f8
    display flex
    justify-content space-between
    align-items center
    border-radius 3px
    height 32px
    padding 8px 12px
    font-size .8rem
    cursor pointer
  .sort-drdn-select-item
    display flex
    align-items center
    cursor pointer
  .sort-drdn-arrow-icon
    font-size 1.1rem
    color #064160
    cursor pointer
  .sort-drdn-list
    background #f2f7f8
    position absolute
    top 32px
    left 0
    box-shadow 3px 4px 8px 0px #999
    background-color #fff
    border-radius 3px
    max-height 270px
    overflow-y auto
    z-index 1
    font-size .8rem
    cursor pointer
  .sort-drdn-item
    background #f2f7f8
    padding 8px 12px
    cursor pointer
  .sort-drdn-item:hover
    background #ddd

  .sort-drdn-list-outsider
    position fixed
    top 0
    left 0
    right 0
    bottom 0

  .sort-drdn-list-date
    position absolute
    top 0
    left 0
    display flex
    width 122px
    align-items center
    cursor pointer

  /*@media (max-width: 440px)
    .lp-sort-drop-down-container
      position unset*/
</style>
